import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-704b7ee2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Icon" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Border Border--initial" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "Border Border--hover",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "50%",
    cy: "50%",
    r: "32.5",
    pathLength: "1"
  })
], -1))
const _hoisted_4 = {
  key: 0,
  class: "Label small-caps"
}

import { withDefaults } from 'vue'

interface Props {
  tag?: 'button' | 'a'
  active?: boolean
}


import { defineComponent } from 'vue'

const __default__ = defineComponent({})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    tag: { default: 'button' },
    active: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { tag: 'button' | 'a', active: boolean }




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tag), {
    class: _normalizeClass(["UIBtn UIBtnRound rounded-full", { 'is-active': __props.active }])
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _renderSlot(_ctx.$slots, "default")
      ]),
      (_ctx.$slots.label)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
            _renderSlot(_ctx.$slots, "label")
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})